import { Tag } from '@cian/components';
import * as React from 'react';

import { IWCCountTag } from '../../../state/tags/definitions/wc_count';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IWCCountTagItemProps {
  tag: IWCCountTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const WCCountTagItem = ({ tag, onDeleteClick, withNewTag }: IWCCountTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Санузлов минимум {tag.value}
    </TagComponent>
  );
};
